(function(){
"use strict";
// Shopify addition: this whole file drives the flex-home section's markup
// (hero plate, service grid, coverage map, command palette). Other page
// templates (cart, 404, etc.) don't render that markup, so bail out early
// there instead of throwing on missing elements. Everything below this
// guard is unmodified from the original site script.
if (!document.getElementById('plate')) { return; }
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ = (id) => document.getElementById(id);

/* ---------- data ---------- */
/* Seasonal availability per RJ's notes:
   spring + summer = same 9 · fall = those 9 + autumn yard cleanup · winter = house cleaning + snow */
const SPR_SUM_FALL = ['spring','summer','autumn'];
const ALL_YEAR     = ['spring','summer','autumn','winter'];

const SERVICES = [
  {n:"Power Washing",         s:SPR_SUM_FALL,  d:"Siding, driveways, decks, and walkways washed back to the surface underneath."},
  {n:"House Cleaning",        s:ALL_YEAR,      d:"Full interior cleaning — a one-time deep clean or a standing recurring visit."},
  {n:"Window Cleaning",       s:SPR_SUM_FALL,  d:"Interior and exterior glass, plus the frames and screens."},
  {n:"Garage Cleanout",       s:SPR_SUM_FALL,  d:"Sort what stays, haul off what doesn't, and sweep the space out."},
  {n:"Pre/Post Construction", s:SPR_SUM_FALL,  d:"Dust, debris, and leftover material cleared before or after a build."},
  {n:"Junk Removal",          s:SPR_SUM_FALL,  d:"Furniture, appliances, and general debris loaded up and taken away."},
  {n:"Pet Fecal Removal",     s:SPR_SUM_FALL,  d:"Yard waste picked up and hauled off, one-time or on a schedule."},
  {n:"Autumn Yard Cleanup",   s:['autumn'],    d:"Leaf removal plus branch and debris cleanup before the snow hits."},
  {n:"Snow Services",         s:['winter'],    d:"Shoveling, salting, and roof raking through the Cleveland winter."},
  {n:"Gutter Cleaning",       s:SPR_SUM_FALL,  d:"Debris pulled from the gutters, downspouts cleared and checked."},
  {n:"Bin Cleaning",          s:SPR_SUM_FALL,  d:"Trash and recycling bins washed out and deodorized."}
];

const SEASON_NAME = {spring:'SPRING', summer:'SUMMER', autumn:'FALL', winter:'WINTER'};
const seasonCount = (k) => SERVICES.filter(x => x.s.includes(k)).length;

// Projected from real lat/long so relative positions match actual geography.
const CITIES = [
  {n:"Cleveland",          x:526, y:425, lx:-10, ly:16,  a:"end",
   zips:["44101","44102","44103","44104","44105","44106","44108","44109","44110","44111","44112","44113","44114","44115","44119","44127","44128","44135"]},
  {n:"Cleveland Heights",  x:706, y:407, lx:11,  ly:-7,  a:"start", zips:["44118"]},
  {n:"University Heights", x:734, y:433, lx:11,  ly:7,   a:"start", zips:["44118"]},
  {n:"Shaker Heights",     x:731, y:468, lx:-11, ly:14,  a:"end",   zips:["44120"]},
  {n:"South Euclid",       x:755, y:387, lx:11,  ly:-6,  a:"start", zips:["44121"]},
  {n:"Lyndhurst",          x:792, y:392, lx:12,  ly:12,  a:"start", zips:["44124"]},
  {n:"Mayfield Heights",   x:832, y:391, lx:12,  ly:-8,  a:"start", zips:["44124"]},
  {n:"Pepper Pike",        x:821, y:488, lx:12,  ly:-6,  a:"start", zips:["44124"]},
  {n:"Beachwood",          x:767, y:484, lx:12,  ly:6,   a:"start", zips:["44122"]},
  {n:"Richmond Heights",   x:778, y:330, lx:12,  ly:-4,  a:"start", zips:["44143"]},
  {n:"Highland Heights",   x:820, y:334, lx:12,  ly:-6,  a:"start", zips:["44143"]},
  {n:"Euclid",             x:744, y:266, lx:12,  ly:2,   a:"start", zips:["44117","44123","44132"]},
  {n:"Lakewood",           x:392, y:454, lx:-11, ly:-7,  a:"end",   zips:["44107"]},
  {n:"Brooklyn",           x:473, y:526, lx:-11, ly:-5,  a:"end",   zips:["44144"]},
  {n:"Parma",              x:490, y:585, lx:-11, ly:6,   a:"end",   zips:["44129","44134"]},
  {n:"Parma Heights",      x:444, y:610, lx:12,  ly:-6,  a:"start", zips:["44130"]},
  {n:"Middleburg Heights", x:373, y:659, lx:-11, ly:8,   a:"end",   zips:["44130"]},
  {n:"Garfield Heights",   x:641, y:564, lx:-11, ly:6,   a:"end",   zips:["44125"]},
  {n:"Maple Heights",      x:695, y:569, lx:12,  ly:6,   a:"start", zips:["44137"]},
  {n:"Rocky River",        x:317, y:465, lx:-11, ly:-6,  a:"end",   zips:["44116"]},
  {n:"Fairview Park",      x:309, y:523, lx:-11, ly:6,   a:"end",   zips:["44126"]},
  {n:"Westlake",           x:236, y:500, lx:-11, ly:6,   a:"end",   zips:["44145"]},
  {n:"Bay Village",        x:229, y:449, lx:-11, ly:-6,  a:"end",   zips:["44140"]},
  {n:"North Olmsted",      x:229, y:566, lx:-11, ly:6,   a:"end",   zips:["44070"]},
  {n:"Brook Park",         x:368, y:596, lx:-11, ly:8,   a:"end",   zips:["44142"]},
  {n:"Seven Hills",        x:553, y:625, lx:12,  ly:-6,  a:"start", zips:["44131"]},
  {n:"Independence",       x:598, y:646, lx:12,  ly:10,  a:"start", zips:["44131"]},
  {n:"Bedford",            x:731, y:605, lx:12,  ly:6,   a:"start", zips:["44146"]},
  {n:"Orange Village",     x:808, y:514, lx:12,  ly:12,  a:"start", zips:["44022"]},
  {n:"Chagrin Falls",      x:922, y:537, lx:-11, ly:10,  a:"end",   zips:["44022"]},
  {n:"Solon",              x:855, y:611, lx:12,  ly:6,   a:"start", zips:["44139"]},
  {n:"Berea",              x:319, y:651, lx:-11, ly:-6,  a:"end",   zips:["44017"]},
  {n:"Olmsted Falls",      x:248, y:649, lx:-11, ly:8,   a:"end",   zips:["44138"]},
  {n:"Strongsville",       x:347, y:738, lx:-11, ly:8,   a:"end",   zips:["44136","44149"]},
  {n:"North Royalton",     x:488, y:740, lx:-11, ly:12,  a:"end",   zips:["44133"]},
  {n:"Broadview Heights",  x:539, y:739, lx:12,  ly:-6,  a:"start", zips:["44147"]},
  {n:"Brecksville",        x:614, y:730, lx:12,  ly:10,  a:"start", zips:["44141"]},
  {n:"Gates Mills",        x:852, y:372, lx:-11, ly:-8,  a:"end",   zips:["44040"]},
  {n:"Valley City",        x:225, y:855, lx:-13, ly:5,   a:"end",   zips:["44280"]},
  {n:"Brunswick",          x:355, y:850, lx:13,  ly:-8,  a:"start", zips:["44212"]},
  {n:"Brunswick Hills",    x:405, y:900, lx:13,  ly:8,   a:"start", zips:["44212"]},
  {n:"Hinckley",           x:530, y:855, lx:13,  ly:5,   a:"start", zips:["44233"]},
  {n:"Avon",               x:108, y:461, lx:-11, ly:-6,  a:"end",   zips:["44011"]}
];

/* zip -> every mapped city that shares it (44124 is Lyndhurst, Mayfield Hts AND Pepper Pike) */
const ZIP_INDEX = {};
CITIES.forEach((c, i) => c.zips.forEach(z => { (ZIP_INDEX[z] = ZIP_INDEX[z] || []).push(i); }));
const ALL_ZIPS = Object.keys(ZIP_INDEX).sort();

/* ---------- basics ---------- */
$('year').textContent = new Date().getFullYear();
$('cityTotal').textContent = CITIES.length + " CITIES MAPPED";

const navToggle = $('navToggle'), mobilePanel = $('mobilePanel');
navToggle.addEventListener('click', () => {
  const open = mobilePanel.classList.toggle('is-open');
  navToggle.classList.toggle('is-open', open);
  navToggle.setAttribute('aria-expanded', String(open));
});
mobilePanel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
  mobilePanel.classList.remove('is-open');
  navToggle.classList.remove('is-open');
  navToggle.setAttribute('aria-expanded','false');
}));

/* scroll progress + active nav */
const bar = $('scrollBar');
const sections = ['services','contact'];
const navA = Array.from(document.querySelectorAll('[data-nav]'));
function onScroll(){
  const h = document.documentElement.scrollHeight - window.innerHeight;
  bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
  let cur = '';
  sections.forEach(id => {
    const el = $(id);
    if (el && el.getBoundingClientRect().top <= 249) cur = id;
  });
  navA.forEach(a => a.classList.toggle('is-current', a.getAttribute('href') === '#' + cur));
}
window.addEventListener('scroll', onScroll, {passive:true});
onScroll();

/* reveal */
const io = new IntersectionObserver((es) => {
  es.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); } });
}, {threshold:0.14});
document.querySelectorAll('.rv').forEach(el => el.classList.add('rv-armed'));
document.querySelectorAll('.rv, .step').forEach(el => io.observe(el));

/* magnetic buttons */
if (!reduced && window.matchMedia('(hover:hover)').matches){
  document.querySelectorAll('.mag').forEach(el => {
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width/2)) * 0.16;
      const dy = (e.clientY - (r.top + r.height/2)) * 0.24;
      el.style.transform = `translate(${dx}px, ${dy}px)`;
    });
    el.addEventListener('pointerleave', () => { el.style.transform = ''; });
  });
}

/* ---------- hero: word swap ---------- */
const swapEl = $('swapWord');
const WORDS = ["in one", "one call", "one crew", "one number"];
if (!reduced){
  let wi = 0;
  const CH = "ABCDEFGHIJKLMNOPQRSTUVWXYZ ";
  function scrambleTo(next){
    const from = swapEl.textContent, len = Math.max(from.length, next.length);
    let frame = 0;
    const timer = setInterval(() => {
      let out = "";
      for (let i = 0; i < len; i++){
        if (i < frame/2) out += next[i] || "";
        else out += (next[i] === " " ? " " : CH[Math.floor(Math.random()*CH.length)]);
      }
      swapEl.textContent = out;
      frame++;
      if (frame/2 >= len){ clearInterval(timer); swapEl.textContent = next; }
    }, 34);
  }
  setInterval(() => { wi = (wi + 1) % WORDS.length; scrambleTo(WORDS[wi]); }, 3600);
}

/* ---------- hero: seasons + hotspots ---------- */
const plate = $('plate');
const readout = $('readoutText');
let readoutSvc = null;
let season = 'summer';

// Which service each spot on the drawing maps to, by season. null = not offered.
const G = ['Gutter Cleaning','GUTTERS + ROOFLINE'];
const W = ['Window Cleaning','WINDOWS'];
const P = ['Power Washing','DRIVEWAY + SIDING'];
const Y = ['Pet Fecal Removal','YARD'];
const B = ['Bin Cleaning','CURB + BINS'];
const H = ['House Cleaning','INTERIOR'];
const HOTSPOTS = {
  roof:     {spring:G, summer:G, autumn:G, winter:['Snow Services','ROOF RAKING']},
  windows:  {spring:W, summer:W, autumn:W, winter:null},
  walk:     {spring:P, summer:P, autumn:P, winter:['Snow Services','SHOVELING + SALTING']},
  yard:     {spring:Y, summer:Y, autumn:['Autumn Yard Cleanup','LEAF REMOVAL'], winter:null},
  bins:     {spring:B, summer:B, autumn:B, winter:null},
  interior: {spring:H, summer:H, autumn:H, winter:H}
};

const hotEls = Array.from(document.querySelectorAll('.hot'));

function resetReadout(){
  readoutSvc = null;
  hotEls.forEach(h => h.classList.remove('on'));
  readout.innerHTML = 'POINT AT A MARKER TO SEE THE SERVICE';
}

function applySeason(next){
  season = next;
  plate.setAttribute('data-season', next);
  hotEls.forEach(h => {
    const cfg = HOTSPOTS[h.dataset.hot][next];
    if (!cfg){
      h.style.display = 'none';
      h.setAttribute('tabindex','-1');
      h.removeAttribute('data-svc');
    } else {
      h.style.display = '';
      h.setAttribute('tabindex','0');
      h.dataset.svc = cfg[0];
      h.querySelector('.hot-txt').textContent = cfg[1];
      h.setAttribute('aria-label', cfg[1] + ' — ' + cfg[0]);
    }
  });
  resetReadout();
}

/* stagger + reveal the hotspots once the line art has drawn itself in */
hotEls.forEach((h, i) => {
  h.querySelectorAll('.hot-lead,.hot-dot,.hot-txt').forEach(el => {
    el.style.transitionDelay = (i * 0.09) + 's';
  });
});
setTimeout(() => plate.classList.add('revealed'), reduced ? 0 : 1850);

document.querySelectorAll('.season-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.season-tab').forEach(t => t.setAttribute('aria-selected','false'));
    tab.setAttribute('aria-selected','true');
    applySeason(tab.dataset.season);
  });
});

hotEls.forEach(h => {
  const show = () => {
    const svc = h.dataset.svc;
    if (!svc) return;
    hotEls.forEach(o => o.classList.remove('on'));
    h.classList.add('on');
    readoutSvc = svc;
    readout.innerHTML = 'SERVICE → <b>' + svc.toUpperCase() + '</b>';
  };
  h.addEventListener('mouseenter', show);
  h.addEventListener('focus', show);
  h.addEventListener('click', show);
  h.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); show(); } });
});

/* ---------- marquee ---------- */
const track = $('marqueeTrack');
const line = SERVICES.map(s => s.n.toUpperCase()).join('|');
track.innerHTML = (line + '|' + line).split('|').map(t => '<span>' + t + '</span>').join('');

/* ---------- services: cards ---------- */
const grid = $('svcGrid');

/* Real icon images the user supplied — used where available.
   Falls back to the hand-drawn SVG set below for the rest. */
const IMAGE_ICONS = {
  "Power Washing":         "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a749338a1eb0203b64fc650.png",
  "Pet Fecal Removal":     "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a749338bd6349ece2dcf2c8.png",
  "Gutter Cleaning":       "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a74948714c02a5229ca8169.png",
  "Pre/Post Construction": "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a749338968debbb0da3c07f.png",
  "Window Cleaning":       "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a749338888087201964a6ee.png",
  "House Cleaning":        "https://assets.cdn.filesafe.space/YVQlP8lETonKadJWQrfe/media/6a749338888087201964a6d9.png"
};

/* one small emoji per service — a light accent next to the name,
   alongside the existing hand-drawn icon, not a replacement for it */
const EMOJI = {
  "Power Washing":         "💦",
  "House Cleaning":        "🧹",
  "Window Cleaning":       "🪟",
  "Garage Cleanout":       "📦",
  "Pre/Post Construction": "🏗️",
  "Junk Removal":          "🗑️",
  "Pet Fecal Removal":     "🐾",
  "Autumn Yard Cleanup":   "🍂",
  "Snow Services":         "❄️",
  "Gutter Cleaning":       "🪜",
  "Bin Cleaning":          "♻️"
};

/* small line drawing per service, drawn on a 40x40 grid */
const ICONS = {
"Power Washing":
  '<path d="M6,10 L28,26"/>' +
  '<path d="M6,10 l-3,-2 M6,10 l1,-4"/>' +
  '<path d="M28,26 L45,19 M28,26 L46,26 M28,26 L45,33"/>' +
  '<path d="M4,42 h32"/>' +
  '<circle cx="14" cy="38" r="1.3"/><circle cx="20" cy="39" r="1.1"/><circle cx="26" cy="37" r="1.4"/>',
"House Cleaning":
  '<path d="M4,22 h18 l-2,18 h-14 z"/>' +
  '<path d="M6,22 q7,-7 14,0"/>' +
  '<path d="M42,4 L26,32"/>' +
  '<path d="M23,32 l-2,7 M26,32 v8 M29,32 l2,7 M32,32 l4,6"/>',
"Window Cleaning":
  '<path d="M5,7 h26 v26 h-26 z"/>' +
  '<path d="M18,7 v26 M5,20 h26"/>' +
  '<path d="M30,44 L41,33"/>' +
  '<path d="M35,29 l7,7 -3,3 -7,-7 z"/>',
"Garage Cleanout":
  '<path d="M4,21 L24,7 L44,21"/>' +
  '<path d="M9,21 h30 v21 h-30 z"/>' +
  '<path d="M13,27 h22 M13,33 h22 M13,39 h22"/>',
"Pre/Post Construction":
  '<path d="M30,4 L20,25"/>' +
  '<path d="M13,25 h16 l3,12 h-22 z"/>' +
  '<path d="M17,29 v8 M22,29 v8 M27,29 v8"/>' +
  '<circle cx="39" cy="34" r="1.6"/><circle cx="43" cy="28" r="1.6"/><circle cx="37" cy="43" r="1.6"/>',
"Junk Removal":
  '<path d="M4,14 h23 v19 h-23 z"/>' +
  '<path d="M27,21 h8 l7,8 v4 h-15"/>' +
  '<circle cx="13" cy="37" r="4"/><circle cx="35" cy="37" r="4"/>' +
  '<path d="M9,20 h13 M9,26 h13"/>',
"Pet Fecal Removal":
  '<path d="M6,30 q0,-8 7,-8 q7,0 7,8 q0,5 -7,5 q-7,0 -7,-5 z"/>' +
  '<circle cx="5" cy="16" r="3.2"/><circle cx="13" cy="12" r="3.2"/><circle cx="21" cy="16" r="3.2"/>' +
  '<path d="M28,44 q-2,-15 4,-16 h4 q6,1 4,16 z"/>' +
  '<path d="M32,28 q0,-5 4,-5 q4,0 4,5"/>',
"Autumn Yard Cleanup":
  '<path d="M24,4 v16"/>' +
  '<path d="M9,21 h30"/>' +
  '<path d="M12,21 v11 M18,21 v11 M24,21 v11 M30,21 v11 M36,21 v11"/>' +
  '<path d="M38,34 q8,5 2,11 q-7,-6 -2,-11 z"/>' +
  '<path d="M40,45 l3,3"/>',
"Snow Services":
  '<path d="M15,6 v22 M5,11 l20,11 M25,11 l-20,11"/>' +
  '<path d="M15,11 l-4,-4 M15,11 l4,-4 M15,23 l-4,4 M15,23 l4,4"/>' +
  '<path d="M37,7 v19"/>' +
  '<path d="M30,26 h14 l-2,9 q-5,5 -10,0 z"/>',
"Gutter Cleaning":
  '<path d="M4,12 L20,6"/>' +
  '<path d="M6,18 h27 v7 h-27 z"/>' +
  '<path d="M28,25 v13 h9"/>' +
  '<path d="M11,18 l2,-4 M16,18 l1,-5 M21,18 l3,-3"/>' +
  '<path d="M41,42 v4"/>',
"Bin Cleaning":
  '<path d="M8,14 h28"/>' +
  '<path d="M18,8 h8 v6 h-8 z"/>' +
  '<path d="M12,14 l2,28 h16 l2,-28 z"/>' +
  '<path d="M19,21 v14 M27,21 v14"/>' +
  '<path d="M40,7 l2,5 5,2 -5,2 -2,5 -2,-5 -5,-2 5,-2 z"/>'
};

SERVICES.forEach((s, i) => {
  const card = document.createElement('div');
  card.className = 'svc-card rv d' + ((i % 4) + 1);
  card.dataset.svc = s.n;
  card.tabIndex = 0;
  card.setAttribute('role','button');
  card.setAttribute('aria-label', s.n + '. ' + s.d);

  const ico = () => IMAGE_ICONS[s.n]
    ? '<div class="ico-wrap"><img class="svc-ico svc-ico-img" src="' + IMAGE_ICONS[s.n] + '" alt="" aria-hidden="true" loading="lazy"></div>'
    : '<div class="ico-wrap"><svg class="svc-ico" viewBox="0 0 48 48" aria-hidden="true">' + (ICONS[s.n] || '') + '</svg></div>';

  card.innerHTML =
    '<div class="svc-inner">' +
      '<div class="face face-front">' +
        '<span class="corner tl"></span><span class="corner br"></span>' +
        '<span class="svc-idx">' + String(i+1).padStart(2,'0') + '</span>' +
        ico() +
        '<h3 class="svc-name"><span class="svc-emoji" aria-hidden="true">' + (EMOJI[s.n] || '') + '</span>' + s.n + '</h3>' +
      '</div>' +
      '<div class="face face-back">' +
        '<span class="corner tl"></span><span class="corner br"></span>' +
        ico() +
        '<p class="svc-desc">' + s.d + '</p>' +
      '</div>' +
    '</div>';

  card.addEventListener('click', () => card.classList.toggle('flip'));
  card.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); card.classList.toggle('flip'); }
  });

  if (!reduced && window.matchMedia('(hover:hover)').matches){
    card.addEventListener('pointermove', (e) => {
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(900px) rotateY(${px*7}deg) rotateX(${-py*7}deg) translateZ(6px)`;
    });
    card.addEventListener('pointerleave', () => { card.style.transform = ''; });
  }

  grid.appendChild(card);
  io.observe(card);
});

applySeason('summer');

/* ---------- map ---------- */
const NS = "http://www.w3.org/2000/svg";
const cityLayer = $('cityLayer'), mapShell = $('mapShell'), areaMap = $('areaMap');
const pDefault = $('pDefault'), pDetail = $('pDetail');
let activeCity = null;

function svg(tag, attrs){
  const el = document.createElementNS(NS, tag);
  for (const k in attrs) el.setAttribute(k, attrs[k]);
  return el;
}

CITIES.forEach((c, i) => {
  const g = svg('g', {class:'city', tabindex:'0', role:'button', 'aria-label': c.n + ' — in service area'});
  g.appendChild(svg('circle', {class:'city-halo', cx:c.x, cy:c.y, r:'10'}));
  g.appendChild(svg('circle', {class:'city-hit', cx:c.x, cy:c.y, r:'18'}));
  g.appendChild(svg('circle', {class:'city-dot', cx:c.x, cy:c.y, r:'5.5'}));
  const t = svg('text', {class:'city-label', x:c.x + c.lx, y:c.y + c.ly, 'text-anchor':c.a});
  t.textContent = c.n.toUpperCase();
  g.appendChild(t);
  g.addEventListener('mouseenter', () => { if ($('citySearch').value.trim() === '') selectCity(i, false); });
  g.addEventListener('focus', () => selectCity(i, false));
  g.addEventListener('click', () => selectCity(i, true));
  g.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); selectCity(i, true); } });
  cityLayer.appendChild(g);
});
const cityNodes = Array.from(cityLayer.querySelectorAll('.city'));

let matchedZip = null;
function selectCity(i, zoom){
  const c = CITIES[i];
  activeCity = i;
  cityNodes.forEach((n, idx) => n.classList.toggle('on', idx === i));
  $('pCity').textContent = c.n;
  $('pZip').textContent = (matchedZip ? 'ZIP ' + matchedZip : 'ZIP ' + c.zips.join(' / ')) + ' · COVERED';
  $('pCta').textContent = 'Start a quote for ' + c.n + ' →';
  const shared = matchedZip && ZIP_INDEX[matchedZip].length > 1
    ? ZIP_INDEX[matchedZip].filter(k => k !== i) : [];
  $('pAlso').innerHTML = shared.length
    ? '<span class="p-near-h">' + matchedZip + ' ALSO COVERS</span><div class="near-list">' +
      shared.map(k => '<button type="button" class="near-chip" data-i="' + k + '">' + CITIES[k].n + '</button>').join('') +
      '</div>' : '';
  $('pAlso').querySelectorAll('.near-chip').forEach(b =>
    b.addEventListener('click', () => selectCity(+b.dataset.i, true)));

  $('pNear').innerHTML = nearest(c.x, c.y, 3, i)
    .map(o => '<button type="button" class="near-chip" data-i="' + o.i + '">' + o.c.n + '</button>').join('');
  $('pNear').querySelectorAll('.near-chip').forEach(b =>
    b.addEventListener('click', () => selectCity(+b.dataset.i, true)));

  pDefault.hidden = true;
  $('pMiss').hidden = true;
  pDetail.hidden = false;
  if (zoom) zoomTo(c);
}

/* nearest mapped cities to a point, by real projected distance */
function nearest(x, y, count, skip){
  return CITIES
    .map((c, i) => ({c, i, d: Math.hypot(c.x - x, c.y - y)}))
    .filter(o => o.i !== skip)
    .sort((a, b) => a.d - b.d)
    .slice(0, count);
}

function showDefault(){
  pDetail.hidden = true;
  $('pMiss').hidden = true;
  pDefault.hidden = false;
}

function showMiss(q){
  $('pMissQ').textContent = q.toUpperCase() + ' — OUTSIDE OUR AREA';
  const c = CITIES[activeCity !== null ? activeCity : 0];
  $('pMissNear').innerHTML = nearest(c.x, c.y, 3, -1)
    .map(o => '<button type="button" class="near-chip" data-i="' + o.i + '">' + o.c.n + '</button>').join('');
  $('pMissNear').querySelectorAll('.near-chip').forEach(b =>
    b.addEventListener('click', () => { $('citySearch').value = ''; clearDim(); selectCity(+b.dataset.i, true); }));
  pDefault.hidden = true;
  pDetail.hidden = true;
  $('pMiss').hidden = false;
}

/* ---------- viewBox zoom ---------- */
const BASE_VB = [-20, 30, 1040, 970];
let curVB = BASE_VB.slice(), vbAnim = null;

function setVB(v){ areaMap.setAttribute('viewBox', v.join(' ')); curVB = v.slice(); }

function animVB(target, done){
  if (vbAnim) cancelAnimationFrame(vbAnim);
  if (reduced){ setVB(target); if (done) done(); return; }
  const from = curVB.slice(), t0 = performance.now(), dur = 620;
  (function step(now){
    const p = Math.min((now - t0) / dur, 1);
    const e = 1 - Math.pow(1 - p, 3);
    setVB(from.map((v, k) => v + (target[k] - v) * e));
    if (p < 1) vbAnim = requestAnimationFrame(step);
    else if (done) done();
  })(performance.now());
}

function zoomTo(c){
  const w = 380, h = 292;
  const x = Math.max(BASE_VB[0], Math.min(c.x - w/2, BASE_VB[0] + BASE_VB[2] - w));
  const y = Math.max(BASE_VB[1], Math.min(c.y - h/2, BASE_VB[1] + BASE_VB[3] - h));
  mapShell.classList.add('zoomed');
  animVB([x, y, w, h]);
}
function resetView(){
  mapShell.classList.remove('zoomed');
  animVB(BASE_VB.slice());
}
$('tReset').addEventListener('click', () => {
  resetView();
  $('citySearch').value = '';
  clearDim();
  cityNodes.forEach(n => n.classList.remove('on'));
  activeCity = null;
  pDetail.hidden = true;
  $('pMiss').hidden = true;
  pDefault.hidden = false;
});

/* HUD — reports the nearest mapped city to the cursor */
const mapStage = $('mapStage');
const hudV = $('hudV'), hudH = $('hudH'), hudT = $('hudT');
if (window.matchMedia('(hover:hover)').matches){
  mapStage.addEventListener('pointermove', (e) => {
    const r = areaMap.getBoundingClientRect();
    const vx = curVB[0] + ((e.clientX - r.left) / r.width) * curVB[2];
    const vy = curVB[1] + ((e.clientY - r.top) / r.height) * curVB[2];
    hudV.setAttribute('x1', vx); hudV.setAttribute('x2', vx);
    hudH.setAttribute('y1', vy); hudH.setAttribute('y2', vy);
    const near = nearest(vx, vy, 1, -1)[0];
    const flip = vx > curVB[0] + curVB[2] * 0.66;
    hudT.setAttribute('x', vx + (flip ? -12 : 12));
    hudT.setAttribute('y', vy - 12);
    hudT.setAttribute('text-anchor', flip ? 'end' : 'start');
    hudT.setAttribute('font-size', Math.round(curVB[2] / 90));
    hudT.textContent = 'NEAREST · ' + near.c.n.toUpperCase();
  });
}

/* map search — ZIP-aware coverage verdict */
function clearDim(){ cityNodes.forEach(n => n.classList.remove('dim')); }

function runCheck(raw){
  const q = raw.trim();
  if (!q){ matchedZip = null; clearDim(); resetView(); showDefault(); return; }

  const digits = q.replace(/\D/g, '');

  // full 5-digit ZIP — the definitive check
  if (digits.length === 5){
    const hits = ZIP_INDEX[digits];
    if (hits){
      matchedZip = digits;
      cityNodes.forEach((n, i) => n.classList.toggle('dim', !hits.includes(i)));
      selectCity(hits[0], true);
    } else {
      matchedZip = null;
      clearDim();
      showMiss('ZIP ' + digits);
    }
    return;
  }

  // partial ZIP — narrow, don't judge yet
  if (digits.length && digits.length === q.length){
    const hits = [];
    CITIES.forEach((c, i) => { if (c.zips.some(z => z.startsWith(digits))) hits.push(i); });
    cityNodes.forEach((n, i) => n.classList.toggle('dim', !hits.includes(i)));
    matchedZip = null;
    if (hits.length) selectCity(hits[0], false); else showDefault();
    return;
  }

  // city name
  const s = q.toLowerCase();
  let first = -1;
  CITIES.forEach((c, i) => {
    const hit = c.n.toLowerCase().includes(s);
    cityNodes[i].classList.toggle('dim', !hit);
    if (hit && first === -1) first = i;
  });
  matchedZip = null;
  if (first !== -1) selectCity(first, true);
  else if (s.length >= 3) showMiss(q);
  else showDefault();
}
$('citySearch').addEventListener('input', (e) => runCheck(e.target.value));

/* scan sweep once visible */
const mapIo = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (e.isIntersecting && !reduced){
      mapShell.classList.add('scanning');
      mapIo.unobserve(e.target);
    }
  });
}, {threshold:0.25});
mapIo.observe(mapShell);

/* layer toggles */
const tHwy = $('tHwy'), hwyLayer = $('hwyLayer');
tHwy.addEventListener('click', () => {
  const on = tHwy.getAttribute('aria-pressed') === 'true';
  tHwy.setAttribute('aria-pressed', String(!on));
  hwyLayer.classList.toggle('off', on);
});
const tLabels = $('tLabels');
tLabels.addEventListener('click', () => {
  const on = tLabels.getAttribute('aria-pressed') === 'true';
  tLabels.setAttribute('aria-pressed', String(!on));
  mapShell.classList.toggle('labels', !on);
});

/* ---------- command palette ---------- */
const veil = $('cmdVeil'), cmdInput = $('cmdInput'), cmdList = $('cmdList');
let cmdItems = [], cmdSel = 0;

const SECTIONS = [
  {kind:'GO', name:'Services', run:() => jump('#services')},
  {kind:'GO', name:'How it works', run:() => jump('#process')},
  {kind:'GO', name:'Service area / coverage check', run:() => jump('#service-area')},
  {kind:'GO', name:'About', run:() => { window.location.href = 'https://teamflexresidential.com/about'; }},
  {kind:'GO', name:'Get a quote', run:() => jump('#contact')},
  {kind:'CALL', name:'Call (440) 409-3786', run:() => { window.location.href = 'tel:4404093786'; }}
];

function jump(hash){
  const el = document.querySelector(hash);
  if (el) el.scrollIntoView({behavior: reduced ? 'auto' : 'smooth'});
}

function buildItems(q){
  const s = q.trim().toLowerCase();
  const out = [];
  const match = (t) => !s || t.toLowerCase().includes(s);

  SECTIONS.filter(x => match(x.name)).forEach(x => out.push(x));

  SERVICES.filter(x => match(x.n)).forEach(x => out.push({
    kind:'SERVICE', name:x.n, note:'View',
    run:() => jump('#services')
  }));

  CITIES.filter(x => match(x.n) || x.zips.some(z => z.startsWith(s))).forEach((x) => out.push({
    kind:'CITY', name:x.n, note:'ZIP ' + x.zips[0],
    run:() => { jump('#service-area'); selectCity(CITIES.indexOf(x), true); }
  }));

  return out.slice(0, 40);
}

function renderCmd(){
  if (!cmdItems.length){
    cmdList.innerHTML = '<p class="cmd-empty">NO MATCHES</p>';
    return;
  }
  const groupOf = (k) => (k === 'SERVICE' ? 'Services' : k === 'CITY' ? 'Cities' : 'Actions');
  let html = '', lastGroup = null;
  cmdItems.forEach((it, i) => {
    const gp = groupOf(it.kind);
    if (gp !== lastGroup){
      html += '<div class="cmd-group">' + gp + '</div>';
      lastGroup = gp;
    }
    html += '<div class="cmd-row' + (i === cmdSel ? ' sel' : '') + '" data-i="' + i + '">' +
              '<span class="r-kind">' + it.kind + '</span>' +
              '<span class="r-name">' + it.name + '</span>' +
              '<span class="r-go">' + (it.note || '↵') + '</span>' +
            '</div>';
  });
  cmdList.innerHTML = html;
  cmdList.querySelectorAll('.cmd-row').forEach(row => {
    row.addEventListener('mouseenter', () => { cmdSel = +row.dataset.i; paintSel(); });
    row.addEventListener('click', () => runSel(+row.dataset.i));
  });
  const sel = cmdList.querySelector('.cmd-row.sel');
  if (sel) sel.scrollIntoView({block:'nearest'});
}
function paintSel(){
  cmdList.querySelectorAll('.cmd-row').forEach(r => r.classList.toggle('sel', +r.dataset.i === cmdSel));
}
function runSel(i){
  const it = cmdItems[i];
  if (!it) return;
  closeCmd();
  it.run();
}
function openCmd(){
  veil.classList.add('open');
  cmdInput.value = '';
  cmdItems = buildItems('');
  cmdSel = 0;
  renderCmd();
  cmdInput.focus();
  document.body.style.overflow = 'hidden';
}
function closeCmd(){
  veil.classList.remove('open');
  document.body.style.overflow = '';
}
$('cmdOpen').addEventListener('click', openCmd);
veil.addEventListener('click', (e) => { if (e.target === veil) closeCmd(); });
cmdInput.addEventListener('input', () => { cmdItems = buildItems(cmdInput.value); cmdSel = 0; renderCmd(); });
cmdInput.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowDown'){ e.preventDefault(); cmdSel = Math.min(cmdSel+1, cmdItems.length-1); paintSel();
    const s = cmdList.querySelector('.cmd-row.sel'); if (s) s.scrollIntoView({block:'nearest'}); }
  else if (e.key === 'ArrowUp'){ e.preventDefault(); cmdSel = Math.max(cmdSel-1, 0); paintSel();
    const s = cmdList.querySelector('.cmd-row.sel'); if (s) s.scrollIntoView({block:'nearest'}); }
  else if (e.key === 'Enter'){ e.preventDefault(); runSel(cmdSel); }
});
document.addEventListener('keydown', (e) => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k'){ e.preventDefault(); veil.classList.contains('open') ? closeCmd() : openCmd(); }
  else if (e.key === 'Escape' && veil.classList.contains('open')) closeCmd();
});

// ================= WORK GALLERY =================
// Progressive enhancement only: the base markup already shows slide 0
// (.is-active) with its caption, a static thumbnail rail, and a plain
// image grid — all of that works with zero JS. This layers on the
// crossfade/Ken-Burns stage, autoplay with a progress bar, thumbnail
// selection, and a lightbox for the grid.
(function(){
  const stageWrap = document.getElementById('galStage');
  if (!stageWrap) return;
  const slides = Array.from(stageWrap.querySelectorAll('.gal-slide'));
  const thumbs = Array.from(stageWrap.querySelectorAll('.gal-thumb'));
  const tagEl = document.getElementById('galTag');
  const titleEl = document.getElementById('galTitle');
  const prevBtn = document.getElementById('galPrev');
  const nextBtn = document.getElementById('galNext');
  const progressBar = document.getElementById('galProgressBar');
  const AUTOPLAY_MS = 7000;
  let current = 0;
  let timer = null;

  function restartKenBurns(slide){
    const img = slide.querySelector('img');
    if (!img || reduced) return;
    img.style.animation = 'none';
    void img.offsetWidth; // force reflow so the animation restarts
    img.style.animation = '';
  }

  function restartProgress(){
    if (!progressBar) return;
    progressBar.classList.remove('is-running');
    void progressBar.offsetWidth;
    if (!reduced) progressBar.classList.add('is-running');
  }

  function goTo(i){
    if (!slides.length) return;
    current = (i + slides.length) % slides.length;
    slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
    thumbs.forEach((t, idx) => {
      t.classList.toggle('is-active', idx === current);
      t.setAttribute('aria-selected', idx === current ? 'true' : 'false');
    });
    const active = slides[current];
    if (tagEl) tagEl.textContent = active.getAttribute('data-tag') || '';
    if (titleEl) titleEl.textContent = active.getAttribute('data-title') || '';
    restartKenBurns(active);
    restartProgress();
  }

  function next(){ goTo(current + 1); }
  function prev(){ goTo(current - 1); }

  function stopAutoplay(){ if (timer){ clearInterval(timer); timer = null; } }
  function startAutoplay(){
    stopAutoplay();
    if (reduced || slides.length < 2) return;
    timer = setInterval(next, AUTOPLAY_MS);
  }

  if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });
  thumbs.forEach((t, idx) => {
    t.addEventListener('click', () => { goTo(idx); startAutoplay(); });
  });

  stageWrap.addEventListener('mouseenter', stopAutoplay);
  stageWrap.addEventListener('mouseleave', startAutoplay);
  stageWrap.addEventListener('focusin', stopAutoplay);
  stageWrap.addEventListener('focusout', startAutoplay);

  // Initialize caption/progress for the first slide, then start the loop.
  goTo(0);
  startAutoplay();
})();

// ================= PROCESS CAROUSEL =================
// A second, separate crossfading carousel (own markup, own timer) —
// simpler than the Work Gallery stage: no arrows or thumbs, just an
// automatic fade through a handful of job photos. The first slide is
// already visible via .is-active in the base markup, so this only
// ever adds motion on top of a page that already looks right.
(function(){
  const wrap = document.getElementById('processCarousel');
  if (!wrap || reduced) return;
  const slides = Array.from(wrap.querySelectorAll('.pc-slide'));
  const captionEl = document.getElementById('pcCaption');
  if (slides.length < 2) return;
  let i = 0;
  setInterval(() => {
    slides[i].classList.remove('is-active');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-active');
    if (captionEl) captionEl.textContent = slides[i].getAttribute('data-caption') || '';
  }, 4500);
})();
})();
